import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

/**
 * Servicio para capturar errores globales del browser.
 * Se inicializa mediante APP_INITIALIZER.
 * El enriquecimiento de logs se hace automáticamente en CustomNGXLoggerServerService.
 */
@Injectable({ providedIn: 'root' })
export class GlobalErrorHandlerService {
  private logger = inject(NGXLogger);
  private platformId = inject(PLATFORM_ID);
  private listenersRegistered = false;

  /**
   * Registra los listeners globales de error.
   * Debe llamarse desde APP_INITIALIZER.
   */
  initialize(): void {
    if (this.listenersRegistered || !isPlatformBrowser(this.platformId)) {
      return;
    }

    window.addEventListener(
      'error',
      event => {
        this.handleGlobalError(event);
      },
      true,
    );
    window.addEventListener('unhandledrejection', event => {
      this.handleUnhandledRejection(event);
    });
  }

  private handleGlobalError(event: ErrorEvent): void {
    try {
      this.logger.error(event.error || event.message, { source: 'global-error' });
    } catch {
      // Fallar silenciosamente
    }
  }

  private handleUnhandledRejection(event: PromiseRejectionEvent): void {
    try {
      this.logger.error(event.reason, { source: 'unhandled-rejection' });
    } catch {
      // Fallar silenciosamente
    }
  }
}
